<script>
  export default {
    name: 'SummaryTable',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {
      init: {
        type: Boolean,
        default: false
      },
      members: {
        type: Array,
        default() {
          return []
        }
      },
      resultData: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      getTotalbaofei(data) {
        if (!data || !data.insurances) return '-'
        const security = data.insurances
        let total = 0
        security.forEach(ins => {
          let baof = ins.baof
          baof = typeof baof === 'number' ? baof : 0
          total += baof
        })
        return total.toFixed(2)
      },
      getInsuranceDataLen(member) {
        let result = 1
        if (!member || !Array.isArray(member.insurances)) return result
        member.insurances.forEach(item => {
          const data = item.insuranceData
          result += Array.isArray(data) ? data.length : 0
        })

        return result
      }
    }
  }
</script>

<template>
  <div class="summary-table">
    <table
      v-if="init && members && members.length"
      class="overview-table"
    >
      <thead>
        <tr>
          <!-- <th>被保人</th> -->
          <th>投保人</th>
          <th>投保日期</th>
          <th>公司</th>
          <th>保障计划</th>
          <th>险种名称</th>
          <th>保障期间</th>
          <th>交费期间</th>
          <th>保险金额(元)</th>
          <th>年交保费(元)</th>
          <th>交费银行</th>
        </tr>
      </thead>
      <tbody
        v-for="(tb, ti) in members"
        :key="`t${ti}`"
      >
        <template v-if="resultData[tb.cid] && resultData[tb.cid].lib.insurances">
          <tr>
            <td colspan="10">
              <span class="head-title">被保人</span>
              <div class="total">
                总年交保费{{ getTotalbaofei(resultData[tb.cid].lib) }}元
              </div>
              <div class="user">
                <div class="head-wrap">
                  <img
                    class="head-image"
                    :src="tb.relationImg"
                    :alt="tb.clientRelation"
                  >
                </div>
                <div class="head-info">
                  {{ tb.name }}
                </div>
              </div>
            </td>
          </tr>
          <tr class="sub">
            <!-- <td>被保人</td> -->
            <td>投保人</td>
            <td>投保日期</td>
            <td>公司</td>
            <td>保障计划</td>
            <td>险种名称</td>
            <td>保障期间</td>
            <td>交费期间</td>
            <td>保险金额(元)</td>
            <td>年交保费(元)</td>
            <td>交费银行</td>
          </tr>
          <!-- <tr>
            <td :rowspan="getInsuranceDataLen(tb)">
              <div class="user">
                <div class="head-wrap">
                  <img class="head-image"
                    :src="tb.relationImg"
                    :alt="tb.clientRelation">
                </div>
                <div class="info">
                  <h5>{{ tb.name }}</h5>
                  <p>{{ getTotalbaofei(resultData[tb.cid].lib) }}元/年</p>
                </div>
              </div>
            </td>
          </tr> -->
          <template v-for="ins in resultData[tb.cid].lib.insurances">
            <template v-if="ins.resultData && ins.resultData.productGroupList && ins.resultData.productGroupList[0]">
              <template v-for="(product, ip) in ins.resultData.productGroupList[0].prodOrderList">
                <tr
                  v-for="(item, index) in product.mulInsOrderList"
                  :key="`i${index + Math.random()}`"
                >
                  <template v-if="ip === 0 && index === 0">
                    <td :rowspan="ins.insuranceData.length">
                      <template v-if="ins.resultData.personData.personOrderList[1] && ins.resultData.personData.personOrderList[1].title">
                        {{ ins.resultData.personData.personOrderList[1].name }}
                      </template>
                    </td>
                    <td :rowspan="ins.insuranceData.length">
                      {{ ins.insuranceDayStr }}
                    </td>
                    <!-- <td :rowspan="ins.insuranceData.length">{{ product.companyName || '--' }}</td> -->
                  </template>
                  <template v-if="index === 0">
                    <td :rowspan="product.mulInsOrderList.length">
                      {{ product.companyName || '--' }}
                    </td>
                    <td :rowspan="product.mulInsOrderList.length">
                      {{ product.titleName }}
                    </td>
                  </template>
                  <td>{{ item.name }}</td>
                  <td>{{ item.iDurationDesc }}</td>
                  <td>{{ item.pPeriodDesc }}</td>
                  <td>{{ item.baoeDesc || item.baoe }}</td>
                  <td>{{ item.baofDesc || item.baof }}</td>
                  <template v-if="ip === 0 && index === 0">
                    <td :rowspan="ins.insuranceData.length">
                      {{ ins.paymentAccountInfo && ins.paymentAccountInfo.bankName || '' }}{{ ins.paymentAccountInfo && ins.paymentAccountInfo.bankCard && ins.paymentAccountInfo.bankCard.substr(-4) }}
                    </td>
                  </template>
                </tr>
              </template>
            </template>
          </template>
          <tr class="note">
            <td>备注</td>
            <td colspan="9" />
          </tr>
        </template>
        <tr v-if="ti === members.length - 1">
          <td class="sweet" colspan="10">
            温馨提示：以上演示说明为本平台对上述产品的理解，便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
  @import 'variable';

  .overview-table {
    thead {
      display: none;
      text-align: center;
      th {
        color: #fff;
        padding: 10px 5px;
      }
      th:nth-child(1) {
        width: 15%;
      }
    }
    tbody {
      tr:first-child {
        td {
          padding: 12px;
          /*background-color: #fdfdfd;*/
          &:last-child {
            font-weight: bold;
          }
        }
      }
      .sub {
        text-align: center;
        td {
          color: #fff;
          border-color: #ffb23e;
          background-color: #ffb23e;
        }
      }
    }
    .user {
      display: flex;
    }
    .info {
      padding-left: 6px;
    }
    .head-wrap {
      /*margin-bottom: 5px;*/
    }
    .head-image {
      display: inline-block;
      width: 36px;
      height: 36px;
      vertical-align: middle;
    }
    .note {
      td:first-child {
        color: #999;
      }
    }
    .sweet {
      color: #999;
      background-color: #fdfdfd;
    }

    .head-title {
      float: left;
      margin-right: 24px;
      line-height: 36px;
      font-weight: bold;
    }
    .total {
      float: right;
      line-height: 36px;
      font-weight: normal;
    }
    .head-info {
      padding-left: 12px;
      line-height: 36px;
      font-weight: normal;
    }
  }
</style>